import React from "react";
import ReactDOM from "react-dom";
import { Router } from "@reach/router";

import App from "./App";

ReactDOM.render(
  <Router>
    <App path="/" default />
  </Router>,
  document.getElementById("root")
);
